module.exports = __webpack_public_path__ + "28b67065/img/copy-icon.408fdb2d.svg";